import React from "react";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import LazyLoad from "react-lazyload";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
const LifeatGis = () => {
  useEffect(() => {
    document.title = "Life at GIS -  Gayatri International School";
  }, []);
  return (
    <>
      <Header />
      <section className="page-header-fb innerslide">
        <div className="innerslide">
          <LazyLoad>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/innerslide.gif"
              className="img-fluid"
            />
          </LazyLoad>{" "}
        </div>
        <div className="page-header__inner">
          <h2>Life at GIS</h2>
          <ul className="thm-breadcrumb list-unstyled ml-0">
            <li>
              <Link to="/HomeFr"> Home</Link>
            </li>
            <li>|</li>
            <li>Academic</li>
            <li>|</li>
            <li>Life at GIS</li>
          </ul>
        </div>
      </section>
      <section className="innerbody">
        <div className="container">
          <div className="row">
            <div className="col-md-12 lagimg">
              <h6>Curriculum</h6>
              <p>
                The proposed modern CBSE-curriculum ensures the physical,
                cognitive, intellectual, emotional and spiritual development of
                learners.A modern pedagogy with a fine blend of best educational
                practices equip learners with 21st century skills.
              </p>

              <h6>Co-curricular Activities</h6>
              <p>
                The school offers a wide range of co-curricular activities to
                develop the skills as well as the personality of learners.
                Students will enjoy an electric mix of activities such as public
                speaking, extempore, debate, elocution etc.
              </p>

              <h6>Swimming Pool</h6>
              <p>
                Our state-of-the-art facilities include modern lap- swimming
                pool designs that summoning summer and providing students with
                an exceptional aquatic experience. Dive into a learning
                environment that embraces both academic rigor and recreational
                excellence.
              </p>

              <div className="row">
                <div className="col-md-3">
                  <a
                    data-magnify="gallery"
                    data-src=""
                    data-group="a"
                    href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/lag1.jpg"
                  >
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/lag1.jpg"
                      className="img-fluid"
                    />
                  </a>
                </div>
                <div className="col-md-3">
                  <a
                    data-magnify="gallery"
                    data-src=""
                    data-group="a"
                    href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/lag2.jpg"
                  >
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/lag2.jpg"
                      className="img-fluid"
                    />
                  </a>
                </div>
                <div className="col-md-3">
                  <a
                    data-magnify="gallery"
                    data-src=""
                    data-group="a"
                    href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/lag3.jpg"
                  >
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/lag3.jpg"
                      className="img-fluid"
                    />
                  </a>
                </div>
              </div>

              <h6>Pedagogy</h6>
              <p>
                The teachers facilitate learning using a pedagogy that is
                modern. The learners are exposed to modern practices that are
                drawn from all over the world. The learning ensures that
                students are equipped with 21st century skills such as
                communication, collaboration, critical thinking and creativity
                to navigate confidently in a fastchanging world.
              </p>

              <h6>Integrating Technology</h6>
              <p>
                The school makes a conscious attempt to integrate technology in
                teaching-learning process to ensure that learners are equipped
                with the knowledge and skills to adapt, grow and excel in a
                technology-driven world.
              </p>

              <div className="row">
                <div className="col-md-3">
                  <a
                    data-magnify="gallery"
                    data-src=""
                    data-group="a"
                    href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/lag4.jpg"
                  >
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/lag4.jpg"
                      className="img-fluid"
                    />
                  </a>
                </div>
                <div className="col-md-3">
                  <a
                    data-magnify="gallery"
                    data-src=""
                    data-group="a"
                    href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/lag5.jpg"
                  >
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/lag5.jpg"
                      className="img-fluid"
                    />
                  </a>
                </div>
                <div className="col-md-3">
                  <a
                    data-magnify="gallery"
                    data-src=""
                    data-group="a"
                    href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/lag6.jpg"
                  >
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/lag6.jpg"
                      className="img-fluid"
                    />
                  </a>
                </div>
                <div className="col-md-3">
                  <a
                    data-magnify="gallery"
                    data-src=""
                    data-group="a"
                    href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/lag7.jpg"
                  >
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/lag7.jpg"
                      className="img-fluid"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default LifeatGis;
